import ResizeObserver from 'resize-observer-polyfill'

export default {
  mounted () {
    this.observeSize()
  },
  data () {
    return {
      width: window.innerWidth,
      height: 0
    }
  },
  computed: {
    isMobile () {
      this.width = window.innerWidth
      return this.width <= 980
    }
  },
  methods: {
    observeSize () {
      const ro = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const {
            width,
            height
          } = entry.contentRect
          this.width = width
          this.height = height
        })
      })

      ro.observe(this.$refs.targetElement)
    }
  }
}
